export enum ConfigMutationTypes {
  SET_SPIN_CONFIG = "SET_SPIN_CONFIG",
  SET_ENCRYPTION_CONFIG = "SET_ENCRYPTION_CONFIG",
  SET_TRUST_CONFIG = "SET_TRUST_CONFIG",
  RESET_ENCRYPTION_CONFIG = "RESET_ENCRYPTION_CONFIG",
  SET_PUBLISH_DATA_CONFIG = "SET_PUBLISH_DATA_CONFIG",
  SET_PUBLISH_API_DATA_CONFIG = "SET_PUBLISH_API_DATA_CONFIG",
}
